// components/layout/HeroSection.js
import React from "react";

/**
 * HeroSection Component
 *
 * This component displays a hero section with a background image and a title.
 * To ensure compatibility and performance, it uses a fallback image in case the primary image fails to load
 * or is not supported by the browser.
 *
 * How the fallback works:
 * - The backgroundImage prop is used to set the primary background image, typically a WebP format for better performance.
 * - The fallbackImage prop provides a secondary image, typically a JPEG, that is used if the primary image fails.
 * - The CSS property `backgroundImage` is set with both URLs. The browser will attempt to load the first URL.
 * - If the browser does not support the WebP format or the image fails to load, it will automatically use the fallback image.
 */

const HeroSection = React.memo(({ backgroundImage, fallbackImage, title }) => {
	return (
		<div
			className="relative bg-no-repeat bg-center bg-cover"
			style={{
				height: "calc(60vh - 56px)",
				backgroundImage: `url(${backgroundImage}), url(${fallbackImage})`,
			}}
		>
			<div className="absolute inset-0 bg-black opacity-50"></div>
			<h1
				className="absolute text-white text-5xl font-bold max-w-[80%] overflow-hidden text-center"
				style={{
					top: "50%",
					left: "50%",
					transform: "translate(-50%, calc(-50% + var(--header-height) / 2))",
					width: "80%",
				}}
			>
				{title}
			</h1>
		</div>
	);
});

// Adding a displayName for better debugging
HeroSection.displayName = "HeroSection";

export default HeroSection;
